import React, { useEffect } from "react"
import { cookieOptanononSettingConfig } from "../utils/footerUtils";
import { replaceImageStyle } from "../utils/common";

export default function FooterComponent({
    content
}) {
    useEffect(() => {
        cookieOptanononSettingConfig();        
    },[]);
    const footerContent = replaceImageStyle(content);
    return (
        <div className="entry-content" dangerouslySetInnerHTML={{ __html: footerContent }} ></div>
    )
}